import React from "react";

import Box from "@mui/material/Box";

import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Tooltip from "@mui/material/Tooltip";

import FrequencyType from "./FrequencyType";
import PeriodType from "../UtilityComponents/GraphOptionUtilityComponents/PeriodType";
import PeriodToggleGroup from "../UtilityComponents/GraphOptionUtilityComponents/PeriodToggleGroup";

const paperPadding = 2;
const enterToolTipDelay = 400;

const FrequencyArray: FrequencyType[] = [
  "daily",
  "weekly",
  "monthly",
  "quarterly",
  // 'annually'
];

type OverviewOptionsProps = {
  frequency: FrequencyType;
  setFrequency: (frequency: FrequencyType) => void;
  referenceDateString: string;
  historicalPeriod: PeriodType;
  setHistoricalPeriod: (historicalPeriod: PeriodType) => void;
  futurePeriod: PeriodType;
  setFuturePeriod: (futurePeriod: PeriodType) => void;
  updateOverviewGraph: () => void;
};

function OverviewOptions(props: OverviewOptionsProps) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: { xs: "center", lg: "space-between" },
        width: "100%",
        height: "100%",
        overflow: "auto",
      }}
    >
      <ToggleButtonGroup // TODO: fix the spacing on this?
        value={props.frequency}
        exclusive
        onChange={(e, newValue) => {
          if (newValue && newValue !== props.frequency) {
            props.setFrequency(newValue);
            props.updateOverviewGraph();
          }
        }}
        sx={{
          px: paperPadding,
          display: { xs: "none", lg: "flex" },
        }}
      >
        {FrequencyArray.map((frequency_option, index) => (
          <Tooltip
            key={index}
            title={`Chart ${frequency_option.toLowerCase()} values.`}
            placement="top-start"
            arrow
            enterDelay={enterToolTipDelay}
          >
            <ToggleButton value={frequency_option} selected={props.frequency === frequency_option}>
              {frequency_option}
            </ToggleButton>
          </Tooltip>
        ))}
      </ToggleButtonGroup>
      <Box sx={{ display: "flex", flexDirection: "row" }}>
        <PeriodToggleGroup period={props.historicalPeriod} setPeriod={props.setHistoricalPeriod} />
        <ToggleButton
          value="check"
          selected={props.futurePeriod !== "Today"}
          onChange={() => {
            props.setFuturePeriod(props.futurePeriod === "Today" ? "Max" : "Today");
          }}
        >
          Projections
        </ToggleButton>
      </Box>
    </Box>
  );
}

export default OverviewOptions;
